import { render, staticRenderFns } from "./RankManager.vue?vue&type=template&id=5bb4c5a3&scoped=true&"
import script from "./RankManager.vue?vue&type=script&lang=js&"
export * from "./RankManager.vue?vue&type=script&lang=js&"
import style0 from "./RankManager.vue?vue&type=style&index=0&id=5bb4c5a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb4c5a3",
  null
  
)

export default component.exports